/* eslint-disable react-hooks/exhaustive-deps */
import { FC, SetStateAction, useEffect } from "react";
import { useRef } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { ReactComponent as Logs } from "assets/svgs/Logs.svg";
import classNames from "classnames";
import appRoutes from "./sideMenu.routes";
import SubMenu from "./subMenu";
import MerchantLogo from "components/MerchantLogo";
import "./sideMenu.module.scss";
import { useOnahSelector } from "store/hooks";
import { Routes } from "routes/routes";

type Props = {
  className?: string;
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  isTablet: boolean;
};
const SideMenu: FC<Props> = ({ className, open, setOpen, isTablet }) => {
  const sidebarRef = useRef<any>();
  const { pathname } = useLocation();
  const { merchant } = useOnahSelector((state) => state.user);

  useEffect(() => {
    if (isTablet) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isTablet]);

  useEffect(() => {
    isTablet && setOpen(false);
  }, [pathname]);

  const Nav_animation = isTablet
    ? {
        open: {
          x: 0,
          width: "272px",
          transition: {
            damping: 40,
          },
        },
        closed: {
          x: -250,
          width: 0,
          transition: {
            damping: 40,
            delay: 0.15,
          },
        },
      }
    : {
        open: {
          width: "272px",
          transition: {
            damping: 40,
          },
        },
        closed: {
          width: "4rem",
          transition: {
            damping: 40,
          },
        },
      };

  return (
    <>
      <div
        onClick={() => setOpen(false)}
        className={`lg:hidden fixed inset-0 max-h-screen z-[998] bg-black/50 ${
          open ? "block" : "hidden"
        } `}
      ></div>
      <motion.aside
        ref={sidebarRef}
        variants={Nav_animation}
        initial={{ x: isTablet ? -272 : 0 }}
        animate={open ? "open" : "closed"}
        className={classNames(
          "bg-white text-gray shadow-xl z-[999] overflow-hidden h-screen lg:h-[calc(100vh-var(--toolbar-height))]",
          "w-[272px] max-2xl:w-[272px] py-[40px] max-2xl:py-[40px] px-[40px] max-2xl:px-[24px]",
          className
        )}
      >
        <div className="flex flex-col h-full justify-between ">
          <div className="flex flex-1 flex-col overflow-hidden">
            <MerchantLogo
              className="!items-start mb-3 flex md:hidden flex-col"
              businessClassName="!text-[22px]"
              spanClassName="!text-[8px]"
            />
            <ul
              className={classNames(
                "whitespace-pre flex flex-col space-y-[10px] overflow-x-hidden",
                "scrollbar-thin scrollbar-track-white scrollbar-thumb-slate-100 flex-1",
                " text-black font-semibold text-xl max-2xl:text-base font-sans overflow-y-auto"
              )}
            >
              {appRoutes.map((menu, i) => (
                <div key={i}>
                  {menu.subRoutes ? (
                    // Render menu item with submenu
                    <SubMenu {...menu} key={menu.id} />
                  ) :
                   (
                    // Render menu item without submenu
                    <li key={menu.id} role="button">
                      <NavLink
                        to={menu.path}
                        // onClick={() => toggleSidebar((prev: boolean) => !prev)}
                        className={({ isActive }) =>
                          [
                            "py-4 max-2xl:py-3 px-[12px] max-2xl:px-[14px] flex items-center group hover:bg-primary-cta space-x-[16px] rounded-lg",
                            isActive
                              ? "bg-primary-cta group text-white active"
                              : "",
                          ]
                            .filter(Boolean)
                            .join(" ")
                        }
                      >
                        <menu.icon
                          className={classNames(
                            "group-hover:text-orange-secondary ",
                            "group-[&.active]:text-orange-secondary"
                          )}
                        />
                        <span className="group-hover:text-white">
                          {menu.label}
                        </span>
                      </NavLink>
                    </li>
                  )}
                </div>
              ))}
            </ul>
          </div>
          {open && (
            <div className="flex flex-col text-sm z-50 max-h-48  whitespace-pre w-full font-semibold mt-1">
              <NavLink
                to={Routes.auditLog}
                  className={({ isActive }) =>
                    [
                      "text-black font-semibold text-xl max-2xl:text-base font-sans",
                      "py-4 max-2xl:py-3 px-[12px] max-2xl:px-[14px] flex items-center group hover:bg-primary-cta space-x-[16px] rounded-lg",
                      isActive
                        ? "bg-primary-cta group text-white active"
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" ")
                  }
                >
                  <Logs className={classNames(
                    "group-hover:text-orange-secondary ",
                    "group-[&.active]:text-orange-secondary"
                  )} />
                  <span className="group-hover:text-white">
                    Audit Logs
                  </span>
                </NavLink>
              <p className="px-3 mt-[32px]  text-base max-2xl:text-sm text-gray-placeholder">
                Merchant ID: {merchant?.onahID}
              </p>
            </div>
          )}
        </div>
      </motion.aside>
    </>
  );
};

export default SideMenu;
